import React from 'react'
import { Flyout, type InfoPopoverProps } from '@adsk/alloy-react-tooltip'
import Theme from '@adsk/alloy-react-theme'

export type FlyoutProps = Omit<InfoPopoverProps, 'style'> & {
	show?: boolean
	message?: string
	children: React.ReactNode
	style?: React.CSSProperties
}
const ConditionalFlyoutComponent = (props: FlyoutProps) => {
	const {
		children,
		show,
		message,
		'data-testid': dataTestId = 'conditionalFlyout',
		style: customStyle,
		...rest
	} = props
	const { spacing } = Theme
	return (
		<Flyout
			shouldWrapChildren
			variant={Flyout.VARIANTS.DARK}
			showArrow={show}
			data-testid={dataTestId}
			style={{
				display: show ? 'block' : 'none',
				padding: spacing.xSmall,
				...customStyle,
			}}
			container={props?.container ?? <span style={{ zIndex: 100000 }}></span>}
			trigger={Flyout.TRIGGER_EVENTS.HOVER}
			content={message}
			{...rest}
		>
			{children}
		</Flyout>
	)
}

export default ConditionalFlyoutComponent
